import React from "react";
import { Link } from "react-router-dom";
import logo from "../Images/logo cover.jpg";

export default function Footer() {
  return (
    <footer className="bg-slate-800 text-gray-300">

      {/* Main Footer */}

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-10">

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Company */}

          <div>

            <Link to="/">
              <img
                src={logo}
                alt="EDRS Logo"
                className="h-14 rounded-lg mb-4"
              />
            </Link>

            <h3 className="text-xl font-bold text-white mb-3">
              EDRS
            </h3>

            <p className="text-sm leading-7 text-gray-400">
              Professional Rebar Estimation, Excel Estimation
              and aSa Software services for residential,
              commercial and industrial construction projects.
            </p>

          </div>

          {/* Quick Links */}

          <div>

            <h4 className="text-lg font-semibold text-white mb-4 relative">

              Quick Links

              <span className="block w-10 h-1 bg-amber-500 rounded mt-2"></span>

            </h4>

            <ul className="space-y-3 text-sm">

              <li>
                <Link to="/" className="hover:text-amber-400 transition">
                  Home
                </Link>
              </li>

              <li>
                <Link to="/aboutus" className="hover:text-amber-400 transition">
                  About Us
                </Link>
              </li>

              <li>
                <Link to="/projects" className="hover:text-amber-400 transition">
                  Projects
                </Link>
              </li>

              <li>
                <Link to="/contact" className="hover:text-amber-400 transition">
                  Contact
                </Link>
              </li>

            </ul>

          </div>

          {/* Services */}

          <div>

            <h4 className="text-lg font-semibold text-white mb-4 relative">

              Services

              <span className="block w-10 h-1 bg-amber-500 rounded mt-2"></span>

            </h4>

            <ul className="space-y-3 text-sm">

              <li>
                <Link
                  to="/services/rebar-estimation"
                  className="hover:text-amber-400 transition"
                >
                  Rebar Estimation
                </Link>
              </li>

              <li>
                <Link
                  to="/services/excel"
                  className="hover:text-amber-400 transition"
                >
                  Excel Estimation
                </Link>
              </li>

              <li>
                <Link
                  to="/services/asa"
                  className="hover:text-amber-400 transition"
                >
                  aSa Software
                </Link>
              </li>

            </ul>

          </div>

          {/* Contact */}

          <div>

            <h4 className="text-lg font-semibold text-white mb-4 relative">

              Contact

              <span className="block w-10 h-1 bg-amber-500 rounded mt-2"></span>

            </h4>

            <div className="space-y-4 text-sm">

              <p className="flex items-start gap-2">
                <span>📍</span>
                <span>Krishnagiri, Tamil Nadu, India</span>
              </p>

              <a
                href="tel:+918667278873"
                className="flex items-center gap-2 hover:text-amber-400 transition"
              >
                <span>📞</span>
                +91 86672 78873
              </a>

              <a
                href="mailto:Estimaterebbar@outlook.com"
                className="flex items-center gap-2 hover:text-amber-400 transition break-all"
              >
                <span>✉️</span>
                Estimaterebbar@outlook.com
              </a>

            </div>

          </div>

        </div>

      </div>

      {/* Bottom Footer */}

      <div className="border-t border-slate-700">

        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row justify-between items-center text-sm">

          <p className="text-gray-400 text-center md:text-left">
            © 2026{" "}
            <span className="font-semibold text-amber-400">
              EDRS
            </span>
            . All Rights Reserved.
          </p>

          <p className="text-gray-500 mt-3 md:mt-0 text-center">
              Designed & Developed by EDRS
          </p>

        </div>

      </div>

    </footer>
  );
}